// tslint:disable:max-line-length

import React from 'react';

export const UtilityMenu = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,1v2h16V1H0z M0,7v2h16V7H0z M0,13v2h16v-2H0z" />
    </svg>
  );
};
